const isLocalhost =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

const baseUrl = isLocalhost
  ? "http://localhost:4001"
  : "https://api.tiendasanjudas.shop";

console.log("🌐 API Base URL:", baseUrl);

export default baseUrl;
